import { Box, BoxProps, RingProgress, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export type WizardStepperProps = BoxProps & {
  currentStepIndex: number;
  stepsCount: number;
  currentStepTitle: string;
  nextStepTitle: string;
};

/**
 * SmallStepper
 */
export const SmallStepper: React.FC<WizardStepperProps> = ({
  currentStepIndex,
  stepsCount,
  currentStepTitle,
  nextStepTitle,
  ...boxProps
}) => {
  const { t } = useTranslation();
  const current = currentStepIndex + 1;
  const total = stepsCount;
  const value = Math.ceil((current / total) * 100);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 8,
      }}
      {...boxProps}
    >
      <RingProgress
        size={64}
        thickness={4}
        label={
          <Text
            size="md"
            fw={600}
            align="center"
            sx={{ pointerEvents: 'none' }}
          >
            {t('common:smallStepper.step', { current, total })}
          </Text>
        }
        sections={[{ value, color: 'violet' }]}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 4,
        }}
      >
        <Text fz="lg" fw={600}>
          {t(currentStepTitle)}
        </Text>
        {nextStepTitle && (
          <Text fz="md" fw={500} c="gray.5">
            {t('common:smallStepper.nextStep', { name: t(nextStepTitle) })}
          </Text>
        )}
      </Box>
    </Box>
  );
};
